import { initControlHandler, Controller, getControlGroup } from '../../500-common/util';

const ATTRIBUTE_CARD_ELEMENT = 'data-klt-c-event-info-card';
const ATTRIBUTE_CARD_OCCURENCE_ELEMENT = 'data-klt-c-event-info-card-occurence';
const ATTRIBUTE_CARD_OCCURENCE_TOGGLE_ELEMENT = 'data-klt-c-event-info-card-occurence-toggle';
const CLASS_OCCURENCE_EXPANDED = 'klt-c-event-info-card__event-occurence--expanded';

/**
 * Element showing the additional information on expanding
 */
const ATTRIBUTE_CARD_OCCURENCE_SECONDARY_ELEMENT = 'data-klt-c-event-info-card-occurence-secondary-info';

enum State {
    Open = 'open',
    FullyBooked = 'fully_booked',
    Expired = 'expired',
}

let cardElements = [];

export default function init() {
    const cardElements = document.querySelectorAll(`[${ATTRIBUTE_CARD_ELEMENT}]`);
    let controller: Controller[] = [];

    if (cardElements.length === 0) {
        return;
    }

    cardElements.forEach((element) => {
        const eventOccurenceCardElements = element.querySelectorAll(`[${ATTRIBUTE_CARD_OCCURENCE_ELEMENT}]`);
        element.classList.add('klt-c-event-info-card--js');

        if (eventOccurenceCardElements.length === 0) {
            return;
        }

        // While going thhrough the occurences, we look for the first occurence
        // with an "open" state and expand that.
        // To not expand further matches, we set this flag here.
        let recommendedMatchExpanded = false;

        eventOccurenceCardElements.forEach((occurenceElement: HTMLElement) => {
            const eventState = occurenceElement.getAttribute(ATTRIBUTE_CARD_OCCURENCE_ELEMENT);
            const target = occurenceElement.querySelector(`[${ATTRIBUTE_CARD_OCCURENCE_SECONDARY_ELEMENT}]`);
            const trigger = occurenceElement.querySelector(`[${ATTRIBUTE_CARD_OCCURENCE_TOGGLE_ELEMENT}]`);
            const group = getControlGroup(trigger);

            let defaultValue = 'false';

            if (!recommendedMatchExpanded && eventState === State.Open) {
                defaultValue = 'true';
                recommendedMatchExpanded = true;
            }

            const newController: Controller = {
                trigger,
                target,
                group,
                controlledAttr: {
                    attr: 'aria-expanded',
                    default: defaultValue,
                },
            };

            controller.push(newController);
        });
    });

    if (controller.length > 0) {
        initControlHandler(controller, applyOccurenceState);
    }
}

/**
 * Adds or removes classes to identify the state of the occurence
 * This is required to handle visual changes as the expanding/collapse
 * functionality is on child level and not accessible to the parent
 * wrapper.
 */
function applyOccurenceState(controller: Controller, expanded: boolean) {
    if (expanded) {
        controller.target.closest(`[${ATTRIBUTE_CARD_OCCURENCE_ELEMENT}]`).classList.add(CLASS_OCCURENCE_EXPANDED);
    } else {
        controller.target.closest(`[${ATTRIBUTE_CARD_OCCURENCE_ELEMENT}]`).classList.remove(CLASS_OCCURENCE_EXPANDED);
    }
}
